module.exports = __webpack_public_path__ + "static/media/file-type.e11520eb.svg";